// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3-MSL","fileBtn":"File_fileBtn__3bUWt","closeBtn":"File_closeBtn__19dHB","fileSelected":"File_fileSelected__16ydk","disabled":"File_disabled__2yw2V"};